/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { Box, useToast, Text, HStack, Image, Spacer } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAlertMessage,
  getAlertType,
  getAlertVisible,
} from "@root/store/selectors/features/alert";
import { hideAlert } from "@root/store/slices/features/alert";
import { TOAST_VARIANT, TOAST_VARIANT_COLORS } from "@root/constants/common";
import WarningIcon from "@root/assets/images/warning.svg";
import SuccessIcon from "@root/assets/images/success.svg";
import InfoIcon from "@root/assets/images/info.svg";
import CancelIcon from "@root/assets/images/cancel.svg";
import { getAlertRedirectTo } from "@root/store/selectors/features/alert";
import { useNavigate } from "react-router-dom";

export const AlertWrapper: React.FC<AlertWrapperProps> = ({ children }) => {
  const dispatch = useDispatch();
  const toast = useToast();
  const toastIdRef: allAnyTypes = React.useRef();
  const message = useSelector(getAlertMessage);
  const type: any = useSelector(getAlertType);
  const visible = useSelector(getAlertVisible);
  const redirectTo = useSelector(getAlertRedirectTo);
  const navigate = useNavigate();
  const renderIcon = () => {
    if (type === TOAST_VARIANT.ERROR) {
      return <Image boxSize={"16px"} src={WarningIcon} />;
    }
    if (type === TOAST_VARIANT.SUCCESS) {
      return <Image boxSize={"16px"} src={SuccessIcon} />;
    }
    if (type === TOAST_VARIANT.WARNING) {
      return <Image boxSize={"16px"} src={WarningIcon} />;
    }
    if (type === TOAST_VARIANT.INFO) {
      return <Image boxSize={"16px"} src={InfoIcon} />;
    }

    return null;
  };

  const handleClose = () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    dispatch(hideAlert());
  };

  const handleToastClick = () => {
    if (!redirectTo) {
      handleClose();
      return;
    }

    // Internal route – use React Router navigation
    navigate(redirectTo);
  };

  useEffect(() => {
    if (visible) {
      const colors = TOAST_VARIANT_COLORS[type];
      const { borderColor, textColor, backgroundColor } = colors;

      toastIdRef.current = toast({
        description: message,
        status: type,
        position: "top-right",
        duration: 5000,
        render: () => (
          <Box borderRadius="md" bgColor={"#FFF"}>
            <Box
              color={textColor}
              bg={backgroundColor}
              height={"40px"}
              pl={"10px"}
              pr={"10px"}
              border="1px solid"
              borderColor={borderColor}
              borderRadius="md"
            >
              <HStack
                spacing={3}
                alignItems="center"
                height="100%"
                cursor={redirectTo ? "pointer" : "default"}
                onClick={handleToastClick}
              >
                {renderIcon()}
                <Text pl={"1px"} fontWeight={400} fontSize={"16px"} isTruncated>
                  {message}
                </Text>
                <Spacer />
                <Image
                  boxSize={"16px"}
                  src={CancelIcon}
                  onClick={(event) => {
                    event.stopPropagation();
                    handleClose();
                  }}
                />
              </HStack>
            </Box>
          </Box>
        ),
      });
    }

    setTimeout(() => {
      dispatch(hideAlert());
    }, 3000);
  }, [visible, type]);

  return <>{children}</>;
};
